import React from 'react'
import { PendingAction, PricingPlan } from './types'
import { PricingPlanElement } from './pricingPlan'

interface PricingPlanListProps {
    pricingPlans: PricingPlan[]
    setPendingAction?: (pendingAction: PendingAction) => void
    readOnly?: boolean
}

export const PricingPlanList = ({ pricingPlans, setPendingAction, readOnly }: PricingPlanListProps) => (
    <ul className="pricing-plan-list">
        {pricingPlans.map((pricingPlan, index) => (
            <PricingPlanElement key={`${pricingPlan.date}-${pricingPlan.status}-${index}`} pricingPlan={pricingPlan} setPendingAction={setPendingAction} readOnly={readOnly} />
        ))}
    </ul>
)
